import SocialLogin from "../components/auth/OAuth/SocialLogin";

const GoogleOAuth = (props) => {
  return (
    <>
      <SocialLogin type='google' />
    </>
  );
};

export default GoogleOAuth;
